module.exports = __webpack_public_path__ + "static/media/exclamation.afc33136.svg";